import { render, staticRenderFns } from "./NotificationsOverlay.vue?vue&type=template&id=6b1210bb&scoped=true&lang=html&"
import script from "./NotificationsOverlay.vue?vue&type=script&lang=js&"
export * from "./NotificationsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsOverlay.vue?vue&type=style&index=0&id=6b1210bb&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1210bb",
  null
  
)

export default component.exports